import { render, staticRenderFns } from "./Discount_by_item.vue?vue&type=template&id=66db1bc3&"
import script from "./Discount_by_item.vue?vue&type=script&lang=js&"
export * from "./Discount_by_item.vue?vue&type=script&lang=js&"
import style0 from "./Discount_by_item.vue?vue&type=style&index=0&id=66db1bc3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports